import { observable, toJS } from 'mobx';

class RegisterStore {
  plugins = observable.map();

  constructor(initial?: any) {
    this.plugins.replace(initial || {});
    window.register = () => {
      let output = Object.entries(toJS(this.plugins)).reduce((acc: any, x) => {
        const [key, value] = x;
        acc[key] = value.description;
        return acc;
      }, {});
      console.log('reregister', output);
    };
  }

  get(guid: string) {
    const plugin = this.plugins.get(guid);
    return !!plugin ? plugin.control : null;
  }

  onMerge(update: any) {
    this.plugins.merge(update || {});
  }
}

export default RegisterStore;
